// ============================================================================
// CASE STATE DATA ENDPOINTS
// ============================================================================
// Backend controller route: CaseStateDataController → /api/v1/CaseStateData.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_STATE_DATA_BASE_PATH = '/CaseStateData';

export const caseStateDataEndpoints = {
  /** List entries for a case (optionally filtered by state_code). */
  list: () => buildEndpoint(CASE_STATE_DATA_BASE_PATH),
  /** Get a single entry by id. */
  getById: (id: ID) => buildEndpointWithParams(`${CASE_STATE_DATA_BASE_PATH}/:id`, { id }),
  /** Upsert form data for a (case, state) — server picks single-entry vs multi-entry per state.allow_multi_entry. */
  save: () => buildEndpoint(CASE_STATE_DATA_BASE_PATH),
  /** Delete an entry (soft delete server-side). */
  delete: (id: ID) => buildEndpointWithParams(`${CASE_STATE_DATA_BASE_PATH}/:id`, { id }),
} as const;

export default caseStateDataEndpoints;
